(function () {
  function initCatalogueModal() {
    const modal = document.getElementById("medisa-catalogue-modal");
    if (!modal) return;

    const form = document.getElementById("medisa-catalogue-form");
    const messageBox = document.getElementById("medisa-catalogue-message");
    const closeButtons = modal.querySelectorAll("[data-catalogue-close]");

    const endpoint = modal.dataset.catalogueEndpoint;
    const catalogueUrl = modal.dataset.catalogueUrl;

    function openModal() {
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("medisa-catalogue-modal-open");
    }

    function closeModal() {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("medisa-catalogue-modal-open");
    }

    function showMessage(text, type) {
      messageBox.hidden = false;
      messageBox.textContent = text;
      messageBox.classList.remove("is-error", "is-success");
      messageBox.classList.add(type === "success" ? "is-success" : "is-error");
    }

    function clearMessage() {
      messageBox.hidden = true;
      messageBox.textContent = "";
      messageBox.classList.remove("is-error", "is-success");
    }

    document.addEventListener("click", function (event) {
      const trigger = event.target.closest('a[href="/pages/catalogue-download"]');

      if (trigger) {
        event.preventDefault();
        openModal();
      }
    });

    closeButtons.forEach(function (btn) {
      btn.addEventListener("click", closeModal);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && modal.classList.contains("is-open")) {
        closeModal();
      }
    });

    if (!form) return;

    form.addEventListener("submit", async function (event) {
      event.preventDefault();
      clearMessage();

      const submitBtn = form.querySelector(".medisa-catalogue-submit");
      submitBtn.disabled = true;
      submitBtn.textContent = "Submitting...";

      const payload = {
        name: form.name.value.trim(),
        organisation: form.organisation.value.trim(),
        email: form.email.value.trim(),
        phone: form.phone.value.trim(),
        website: form.website.value.trim(),
        source_page: window.location.href,
        store_domain: window.location.hostname,
        catalogue_url: catalogueUrl
      };

      try {
        const response = await fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        });

        const data = await response.json().catch(function () {
          return {};
        });

        if (!response.ok) {
          throw new Error(data.message || "Submission failed.");
        }

        showMessage("Success. Redirecting...", "success");

        setTimeout(function () {
  window.open(catalogueUrl, '_blank', 'noopener');
  closeModal();
}, 700);

      } catch (error) {
        showMessage(error.message || "Something went wrong.", "error");
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = "Submit & Download";
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCatalogueModal);
  } else {
    initCatalogueModal();
  }
})();